<template>
  <div>
    <gat-grid
      :items="people"
      :columns="columns"
      title="People"
      reloadBtn
      @reload-clicked="fetchData()"
      :rowclass="this.getRowClass"
      :loading="isLoading"
      viewGroupName="viewPeopleList"
      :height="windowHeight"
      :fixedheader="true"
      :dense="denseMode"
      :selectable="isSelectable"
      keyName="ID"
      hide-empty-columns
      :selectedKeys="selectedItemKeys"
      @selectionChanged="showLinkedTasks($event)"
      @row-clicked="goToCrewChangePerson($event)">
      <template slot="btns">
        <wm-button-group
          class="right mr-1"
          :buttons="wmButtonGroup"
          @createEmailClick="(val) => createEmailClick(val)"
          @addClick="goToNewCrewChangePerson" />
      </template>

      <template slot="cell" slot-scope="props">
        <div v-if="props.column.field == 'STATUS'">
          <v-tooltip bottom v-if="props.value == 0">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="blue" v-bind="attrs" v-on="on">mdi-timer-sand-empty</v-icon>
            </template>
            <span>In progress</span>
          </v-tooltip>
          <v-tooltip bottom v-else-if="props.value == 1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="green" v-bind="attrs" v-on="on">mdi-check-circle</v-icon>
            </template>
            <span>Completed</span>
          </v-tooltip>
          <v-tooltip bottom v-else-if="props.value == 2">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="red" v-bind="attrs" v-on="on">mdi-alert-circle</v-icon>
            </template>
            <span>Cancelled</span>
          </v-tooltip>
          <v-tooltip bottom v-if="props.row.LOCK_FLAG && props.row.LOCK_FLAG === 1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="ml-1" color="grey--darken-2" v-bind="attrs" v-on="on" small>mdi-lock</v-icon>
            </template>
            <span>Locked</span>
          </v-tooltip>
        </div>
        <div v-else-if="props.column.field == 'hasRemark'">
          <v-tooltip bottom v-if="props.value == 1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">mdi-message-bulleted</v-icon>
            </template>
            <span>{{ props.row.REMARKS }}</span>
          </v-tooltip>
        </div>
        <div v-else-if="props.column.field == 'Attachment'">
          <v-tooltip bottom v-if="props.value == 1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">mdi-paperclip</v-icon>
            </template>
            <span>Attachments</span>
          </v-tooltip>
        </div>
        <div v-else-if="props.column.field == 'PERSON_TYPE'">
          <v-tooltip bottom v-if="props.value == 0">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">mdi-account-hard-hat</v-icon>
            </template>
            <span>Crew</span>
          </v-tooltip>
        </div>
        <div v-else-if="props.column.field == 'PERSON_TYPE'">
          <v-tooltip bottom v-if="props.value == 1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">mdi-account-cash</v-icon>
            </template>
            <span>Passenger</span>
          </v-tooltip>
          <v-tooltip bottom v-else-if="props.value == 2">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">mdi-account</v-icon>
            </template>
            <span>Other</span>
          </v-tooltip>
        </div>
        <div v-else-if="props.column.field == 'OPERATION'">
          <v-tooltip bottom v-if="props.value == 0">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="green" v-bind="attrs" v-on="on">mdi-airplane-landing</v-icon>
            </template>
            <span>Embarking</span>
          </v-tooltip>
          <v-tooltip bottom v-else-if="props.value == 1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="red" v-bind="attrs" v-on="on">mdi-airplane-takeoff</v-icon>
            </template>
            <span>Disembarking</span>
          </v-tooltip>
          <v-tooltip bottom v-else-if="props.value == 2">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="blue" v-bind="attrs" v-on="on">mdi-circle-double</v-icon>
            </template>
            <span>Other</span>
          </v-tooltip>
        </div>
        <div v-else-if="props.column.field == 'MOBILEPHONE'">
          <a :href="'tel:' + props.value" class="gridLink">{{ props.value }}</a>
        </div>
      </template>
    </gat-grid>
    <email-generator
      ref="emailGenerator"
      :portcallId="callId"
      location="portcall"
      @isLoadingOverlay="isLoading = $event" />
  </div>
</template>

<script>
import { apiGet } from '@/store/api';
import GatUtils from '@/app-components/GatUtils';
import EmailGenerator from '@/app-components/EmailGenerator.vue';
import { useAppStatusStore } from '@/store/appStatusStore';
import { useApplicationStore } from '@/store/applicationStore';
import { usePortcallStore } from '@/store/portcallStore';
import { useHelperStore } from '@/store/helperStore';
import { getCrewChangePeople } from '@/services/api/api-calls/getCrewChangePeople';
import { getCrewChangeGridFields } from '@/services/api/api-calls/getCrewChangeGridFields';

export default {
  name: 'CrewChangePeopleList',
  props: {
    callId: [Number, String],
    fullsize: [Boolean],
  },
  components: { EmailGenerator },
  setup() {
    const appStatusStore = useAppStatusStore();
    const applicationStore = useApplicationStore();
    const portcallStore = usePortcallStore();
    const helperStore = useHelperStore();
    return {
      helperStore,
      portcallStore,
      applicationStore,
      appStatusStore,
    };
  },
  data() {
    return {
      isLoading: false,
      selectedItemKeys: [],
      peopleByTask: [],
      taskListHeight: null,
      personFilter: [],
      taskFilter: [],
      operationFilter: [],
      statusFilter: [],
      denseMode: false,
      upcomingPeople: {},
      emailTemplates: [],
      gridFieldConfig: [],
    };
  },

  activated() {
    this.fetchData();
    this.fetchGridFieldConfig();
  },

  mounted() {
    window.messageBus.$on('peopleFilteredByTask', (peopleArray) => {
      this.selectedItemKeys = [];
      this.peopleByTask = GatUtils.makeCopyViaJson(peopleArray);
    });

    window.messageBus.$on('crewChangeTaskListHeight', (taskListHeight) => {
      this.taskListHeight = taskListHeight;
    });

    window.messageBus.$on('crewChangeFilterOperation', (operationChoice) => {
      this.operationFilter = operationChoice;
    });

    window.messageBus.$on('crewChangeFilterStatus', (statusChoice) => {
      this.statusFilter = statusChoice;
    });

    window.messageBus.$on('crewChangeFilterPerson', (personChoice) => {
      this.personFilter = personChoice;
    });

    window.messageBus.$on('crewChangeFilterTask', (taskChoice) => {
      this.taskFilter = taskChoice;
    });

    window.messageBus.$on('crewChangeFilterDense', (denseChoise) => {
      this.denseMode = denseChoise;
    });
  },

  created() {
    // this.fetchData();
  },

  watch: {
    agencyId() {
      return this.fetchEmailTemplates();
    },
    // callId: {
    //   handler() {
    //     this.fetchData();
    //   },
    //   immediate: true,
    // },
    externalClientId: {
      handler() {
        this.fetchData();
      },
    },
  },

  computed: {
    externalClientId() {
      return this.applicationStore.user.externalClientId;
    },
    columns() {
      // Define all possible columns mapped to their ccm_field FIELDNAME
      const allColumns = {
        cPeople_Operation: { header: 'Op.', field: 'OPERATION' },
        cPeople_Person_type: { header: 'Ty.', field: 'PERSON_TYPE' },
        cPeople_Status: { header: 'Status', field: 'STATUS' },
        cPeople_Sequence: { header: 'Seq', field: 'SEQUENCE' },
        cPeople_HasRemark: { header: 'Rem', field: 'hasRemark' },
        cPeople_Attachment: { header: 'Doc.', field: 'Attachment' },
        cPeople_Lastname: { header: 'Lastname', field: 'LASTNAME' },
        cPeople_Firstname: { header: 'Firstname', field: 'FIRSTNAME' },
        cPeople_Fullname: { header: 'Fullname', field: 'FULLNAME', nowrap: true },
        cPeople_Transp: { header: 'Transp.', field: 'Transp' },
        cPeople_Accom: { header: 'Accom.', field: 'Accom' },
        cPeople_Mobilephone: { header: 'Mobile', field: 'MOBILEPHONE', nowrap: true },
        cPeople_Gender: { header: 'Gender', field: 'GENDER' },
        cPeople_Nationality: { header: 'Nat.', field: 'NATIONALITY' },
        cPeople_Rank: { header: 'Rank', field: 'RANK', nowrap: true },
        cPeople_Passport_number: { header: 'Pass number', field: 'PASSPORT_NUMBER' },
        cPeople_Passport_issued_date: { header: 'Pass issued date', field: 'PASSPORT_ISSUED_DATE', dataType: 'date' },
        cPeople_Passport_valid_to: { header: 'Pass valid to', field: 'PASSPORT_VALID_TO', dataType: 'date' },
        cPeople_Seamanbook_Number: { header: 'Seaman number', field: 'SEAMANBOOK_NUMBER' },
        cPeople_Seamanbook_issued_date: {
          header: 'Seaman issued date',
          field: 'SEAMANBOOK_ISSUED_DATE',
          dataType: 'date',
        },
        cPeople_Seamanbook_Valid_To: { header: 'Seaman valid to', field: 'SEAMANBOOK_VALID_TO', dataType: 'date' },
        cPeople_ExpTotal: {
          header: 'Exp. total',
          field: 'ExpTotal',
          footerFunction: { fn: 'sum' },
          dataType: 'number',
        },
        cPeople_Debtor: { header: 'Debtor', field: 'Debtor', nowrap: true },
        cPeople_Last_updated: { header: 'Updated', field: 'LAST_UPDATED', dataType: 'datetime' },
        cPeople_Last_updated_by: { header: 'Updated by', field: 'LAST_UPDATED_BY' },
        cPeople_Last_exported: { header: 'Exported', field: 'LAST_EXPORTED', dataType: 'datetime' },
        cPeople_Last_exported_by: { header: 'Exported by', field: 'LAST_EXPORTED_BY' },
        cPeople_Remark: { header: 'Remark', field: 'REMARKS' },
      };

      // Permission-based column restrictions
      const permissionFilter = (fieldName) => {
        const internalOnly = [
          'cPeople_HasRemark',
          'cPeople_Attachment',
          'cPeople_Lastname',
          'cPeople_Firstname',
          'cPeople_Transp',
          'cPeople_Accom',
          'cPeople_Seamanbook_Number',
          'cPeople_Seamanbook_issued_date',
          'cPeople_Seamanbook_Valid_To',
          'cPeople_Last_updated',
          'cPeople_Last_updated_by',
          'cPeople_Last_exported',
          'cPeople_Last_exported_by',
          'cPeople_Remark',
        ];
        if (internalOnly.includes(fieldName) && !this.applicationStore.user.internal) {
          return false;
        }
        // Passport details require internal or specific right
        const passportCols = ['cPeople_Passport_number', 'cPeople_Passport_issued_date', 'cPeople_Passport_valid_to'];
        if (
          passportCols.includes(fieldName) &&
          !this.applicationStore.user.internal &&
          !this.applicationStore.userRight('CRCH.SHOW_PASSPORT_DETAILS')
        ) {
          return false;
        }
        // Expense-related columns
        const expenseColumns = ['cPeople_ExpTotal', 'cPeople_Debtor'];
        if (expenseColumns.includes(fieldName) && !this.applicationStore.userRight('CRCH.SHOW_EXPENSES')) {
          return false;
        }
        return true;
      };

      // Build dynafield columns
      const getDynaFieldColumns = () => {
        const dynaCols = [];
        if (!this.applicationStore.user.internal) return dynaCols;
        const peopleDynafields = [];
        const personer = this.portcallStore.crewChange.people.persons;
        if (personer) {
          personer.forEach((person) => {
            Object.keys(person).forEach((vars) => {
              if (vars.startsWith('dyn_')) peopleDynafields.push(vars);
            });
          });
          for (let index = 0; index < this.helperStore.dynafields.length; index++) {
            const dynafield = this.helperStore.dynafields[index];
            if (dynafield.COMPONENT_NAME == 'pDynaFields.CrewChangeDynaPerson') {
              if (peopleDynafields.includes(`dyn_${dynafield.ID}`)) {
                const col = {
                  header: dynafield.CAPTION,
                  field: `dyn_${dynafield.ID}`,
                  dataType: this.getDataTypeByFieldTypeId(dynafield.FIELD_TYPE),
                };
                if (col.dataType === 'number') {
                  col.numberFormat = '0,0';
                }
                dynaCols.push(col);
              }
            }
          }
        }
        return dynaCols;
      };

      // Build expense template columns
      const getExpenseColumns = () => {
        const expCols = [];
        if (!this.applicationStore.userRight('CRCH.SHOW_EXPENSES')) return expCols;
        let templates;
        if ((this.isTransportPage || this.isAccommodationPage) && this.upcomingPeople?.usedExpenseTemplates) {
          templates = this.upcomingPeople.usedExpenseTemplates;
        } else if (this.portcallStore.crewChange.people?.usedExpenseTemplates) {
          templates = this.portcallStore.crewChange.people.usedExpenseTemplates;
        }
        if (templates) {
          for (let i = 0; i < templates.length; i++) {
            expCols.push({
              header: templates[i].CAPTION,
              field: `exp_${templates[i].ID}`,
              footerFunction: { fn: 'sum' },
              dataType: 'number',
            });
          }
        }
        return expCols;
      };

      // If we have grid field config, use it for ordering and visibility
      if (this.gridFieldConfig && this.gridFieldConfig.length > 0) {
        const result = [];
        const visibleConfiguredColumns = [];
        let dynaSortOrder = Infinity;
        let expenseSortOrder = Infinity;
        const dynaColumns = getDynaFieldColumns();
        const expenseColumns = getExpenseColumns();

        this.gridFieldConfig.forEach((fieldConfig) => {
          const fieldName = fieldConfig.FIELDNAME.trim();
          const normalizedFieldName = fieldName.toUpperCase();

          if (normalizedFieldName === '[DYNAMIC FIELDS]') {
            dynaSortOrder = fieldConfig.SORT_ORDER;
            return;
          }
          if (normalizedFieldName === '[EXPENSES]') {
            expenseSortOrder = fieldConfig.SORT_ORDER;
            return;
          }

          const colDef = allColumns[fieldName];
          if (colDef && fieldConfig.VISIBLE === 1 && permissionFilter(fieldName)) {
            result.push(colDef);
            visibleConfiguredColumns.push({
              field: colDef.field,
              sortOrder: fieldConfig.SORT_ORDER,
            });
          }
        });

        // Helper to find insertion index for placeholder columns
        const findInsertIndex = (placeholderSortOrder) => {
          for (let index = 0; index < visibleConfiguredColumns.length; index++) {
            const nextVisibleColumn = visibleConfiguredColumns[index];
            if (nextVisibleColumn.sortOrder > placeholderSortOrder) {
              const idx = result.findIndex((col) => col.field === nextVisibleColumn.field);
              if (idx !== -1) {
                return idx;
              }
            }
          }
          return result.length;
        };

        const placeholderColumns = [
          { columns: dynaColumns, sortOrder: dynaSortOrder, typeOrder: 0 },
          { columns: expenseColumns, sortOrder: expenseSortOrder, typeOrder: 1 },
        ]
          .filter((entry) => entry.columns.length > 0)
          .sort((left, right) => {
            if (left.sortOrder === right.sortOrder) {
              return left.typeOrder - right.typeOrder;
            }
            return left.sortOrder - right.sortOrder;
          });

        placeholderColumns.forEach((entry) => {
          result.splice(findInsertIndex(entry.sortOrder), 0, ...entry.columns);
        });

        return result;
      }

      // Fallback: original hardcoded column order (when no config available)
      const result = [];
      result.push(allColumns.cPeople_Operation);
      result.push(allColumns.cPeople_Person_type);
      result.push(allColumns.cPeople_Status);
      result.push(allColumns.cPeople_Sequence);
      if (this.applicationStore.user.internal) {
        result.push(allColumns.cPeople_HasRemark);
        result.push(allColumns.cPeople_Attachment);
        result.push(allColumns.cPeople_Lastname);
        result.push(allColumns.cPeople_Firstname);
      }
      result.push(allColumns.cPeople_Fullname);
      if (this.applicationStore.user.internal) {
        result.push(allColumns.cPeople_Transp);
        result.push(allColumns.cPeople_Accom);
      }
      result.push(allColumns.cPeople_Mobilephone);
      result.push(allColumns.cPeople_Gender);
      result.push(allColumns.cPeople_Nationality);
      result.push(allColumns.cPeople_Rank);
      if (this.applicationStore.user.internal || this.applicationStore.userRight('CRCH.SHOW_PASSPORT_DETAILS')) {
        result.push(allColumns.cPeople_Passport_number);
        result.push(allColumns.cPeople_Passport_issued_date);
        result.push(allColumns.cPeople_Passport_valid_to);
      }
      if (this.applicationStore.user.internal) {
        result.push(allColumns.cPeople_Seamanbook_Number);
        result.push(allColumns.cPeople_Seamanbook_issued_date);
        result.push(allColumns.cPeople_Seamanbook_Valid_To);
        result.push(...getDynaFieldColumns());
      }
      // Expense columns
      if (this.applicationStore.userRight('CRCH.SHOW_EXPENSES')) {
        result.push(...getExpenseColumns());
        result.push(allColumns.cPeople_ExpTotal);
        result.push(allColumns.cPeople_Debtor);
      }
      if (this.applicationStore.user.internal) {
        result.push(allColumns.cPeople_Last_updated);
        result.push(allColumns.cPeople_Last_updated_by);
        result.push(allColumns.cPeople_Last_exported);
        result.push(allColumns.cPeople_Last_exported_by);
        result.push(allColumns.cPeople_Remark);
      }
      return result;
    },
    people() {
      if (
        (!this.userRightsPeople || this.isTransportPage || this.isAccommodationPage) &&
        this.peopleByTask.length === 0
      ) {
        return [];
      }

      let people = [];
      let peopleFiltered = null;

      if (this.isTransportPage || this.isAccommodationPage) {
        if (this.upcomingPeople.persons && this.upcomingPeople.persons.length > 0) {
          people = GatUtils.makeCopyViaJson(this.upcomingPeople.persons);
        }
      } else {
        people = this.portcallStore.crewChange.people.persons;
      }

      if (people) {
        peopleFiltered = GatUtils.makeCopyViaJson(people);
        peopleFiltered = this.filterItems(peopleFiltered, this.operationFilter, 'OPERATION');
        peopleFiltered = this.filterItems(peopleFiltered, this.personFilter, 'PERSON_TYPE');
        peopleFiltered = this.filterItems(peopleFiltered, this.statusFilter, 'STATUS');

        if (this.taskFilter[0] && this.taskFilter[1]) {
          peopleFiltered = peopleFiltered.filter((person) => !(person.Transp && person.Accom));
        } else if (this.taskFilter[0]) {
          peopleFiltered = peopleFiltered.filter((person) => !person.Transp);
        } else if (this.taskFilter[1]) {
          peopleFiltered = peopleFiltered.filter((person) => !person.Accom);
        }

        if (this.peopleByTask.length > 0) {
          peopleFiltered = peopleFiltered.filter((person) => this.peopleByTask.includes(person.ID));
        }
      }
      return peopleFiltered || people;
    },
    windowHeight() {
      let height = 77;
      const defaultHeight = 45;
      if (this.fullsize) {
        return 'calc(100vh - 170px)';
      }
      if (this.taskListHeight != null) {
        height -= this.taskListHeight;
      } else {
        height = defaultHeight;
      }

      return `${height}vh`;
    },
    agencyId() {
      return this.portcallStore.callDetails.SETUP_ID;
    },
    wmButtonGroup() {
      const result = [];
      if ((!this.applicationStore.user.internal && this.userCanGenerateDoc) || this.applicationStore.user.internal) {
        result.push({
          btnType: 'CREATE_DOC',
          docType: 23,
          agencyId: this.agencyId,
          location: 'portcall',
          foreignKey: this.callId,
          applicationStatus: this.applicationStatus,
          disabled: !this.userCanGenerateDoc, // this.selectedItemKeys.length === 0 ||
        });
        if (
          this.applicationStore.globalSettings.SGL_WM_EMAIL_PROVIDER !== 0 &&
          this.applicationStore.userRight('EM.EDIT')
        ) {
          result.push({
            btnType: 'CUSTOM',
            caption: 'Create email',
            icon: 'mdi-email',
            menuItems: this.emailTemplateItems,
            disabled: this.emailTemplateItems.length === 0 || !this.selectedItemKeys.length,
          });
        }
      }
      result.push({ btnType: 'ADD' });

      return result;
    },
    userCanGenerateDoc() {
      const isInternal = this.applicationStore.user.internal;
      if (isInternal) {
        return true;
      }
      const externalRights = this.applicationStore.userRight('CRCH.GENERATE_DOCUMENT');
      return externalRights;
    },
    isSelectable() {
      if (this.peopleByTask.length > 0) {
        return false;
      }
      return true;
    },
    applicationStatus() {
      return this.appStatusStore.getAppStatus;
      /* let result = {};
              result.PortCall = {};
              result.PortCall.Id = this.callId;
              result.PortCall.CcmPersonIds = this.selectedItemKeys
              return result; */
    },
    userRightsTasks() {
      return (
        this.applicationStore.user.internal ||
        this.applicationStore.userRight('CRCH.ACCESS') ||
        this.applicationStore.userRight('CRCH.ACCESS_OWN_TASK')
      );
    },
    userRightsPeople() {
      return this.applicationStore.user.internal || this.applicationStore.userRight('CRCH.ACCESS_ALL_PERSONS');
    },
    clientId() {
      if (
        this.applicationStore.user.internal ||
        this.applicationStore.userRight('CRCH.ACCESS_ALL_PERSONS') ||
        this.applicationStore.userRight('CRCH.ACCESS')
      ) {
        return 0;
      }
      return this.applicationStore.user.externalClientId ? this.applicationStore.user.externalClientId : null;
    },
    isTransportPage() {
      return this.$route.path === '/transports';
    },
    isAccommodationPage() {
      return this.$route.path === '/accommodations';
    },
    emailTemplateItems() {
      const templates = [...this.emailTemplates];
      let result = [];
      if (Array.isArray(templates) && templates.length > 0) {
        const ignoreGroupMinCount = this.applicationStore.hasFeatureCode('IGNORE_DOCUMENT_GROUPING_MIN_COUNT');

        if (ignoreGroupMinCount ? true : templates.length > 10) {
          result = this.helperStore.emailTemplatesGroupedByLabels(templates, false);
        } else {
          result = templates.map((item) => ({
            caption: item.TITLE,
            eventName: 'createEmailClick',
            icon: 'mdi-file-outline',
            ID: item.ID,
          }));
        }
      }
      return result;
    },
  },

  methods: {
    fetchGridFieldConfig() {
      getCrewChangeGridFields(0).then((result) => {
        if (result && result.length > 0) {
          this.gridFieldConfig = result;
        }
      });
    },
    goToCrewChangePerson(rowItem) {
      this.$router.push({ name: 'crewChangePerson', params: { personID: rowItem.ID } });
    },
    goToNewCrewChangePerson() {
      const sequence = (this.people.length + 1) * 10;
      this.$router.push({ name: 'newCrewChangePerson', params: { callId: this.callId, sequence } });
    },
    async createEmailClick(item) {
      const template = this.emailTemplates.find((entry) => entry.ID === item.ID);
      if (this.callId && template) {
        await this.$refs.emailGenerator.generateEmail(template, this.applicationStatus);
      }
    },
    retrievePeople(callId) {
      this.isLoading = true;
      getCrewChangePeople({ callId, clientId: this.clientId })
        .then(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    filterItems(people, filterArray, property) {
      const numOfOperationsToggled = filterArray.filter((op) => op === true).length;
      if (numOfOperationsToggled > 0 && numOfOperationsToggled != filterArray.length) {
        const newFilter = filterArray.reduce((result, element, index) => {
          if (element) {
            result.push(index);
          }
          return result;
        }, []);

        // eslint-disable-next-line no-param-reassign
        people = people.filter((person) => {
          if (newFilter.includes(person[property])) {
            return true;
          }
          return false;
        });
      }
      return people;
    },

    getRowClass(rowItem) {
      let result = '';
      if (rowItem.STATUS === 2) {
        result += 'ignored';
      }
      return result;
    },
    showLinkedTasks(peopleIds) {
      if (this.userRightsTasks) {
        this.selectedItemKeys = peopleIds;
        this.appStatusStore.setAppStatusCcmPersonIds(peopleIds);
        this.isLoading = true;
        let taskArray = [];
        if (peopleIds.length == 0) {
          window.messageBus.$emit('tasksFilteredByPeople', taskArray);
          this.isLoading = false;
        } else {
          const selectedPeopleItems = this.getPeopleItemBySelectedKeys();
          taskArray = this.getTasksFromPeople(selectedPeopleItems);
          if (taskArray.length > 0) {
            window.messageBus.$emit('tasksFilteredByPeople', taskArray);
          } else {
            // People selected but no assigned tasks > Clear task table
            window.messageBus.$emit('tasksFilteredByPeople', ['x']);
          }
          this.isLoading = false;
        }
      }
    },
    fetchData() {
      if (this.callId != 0) {
        if (this.portcallStore.crewChange.people) {
          this.retrievePeople(this.callId);
        }
        this.fetchEmailTemplates();
      } else {
        this.retrieveUpcomingTasksPeople();
      }
    },
    async fetchEmailTemplates() {
      const { callId, agencyId } = this;
      this.emailTemplates = [];
      if (!callId || Number(callId) === 0 || !agencyId) return;
      const templates = await apiGet(`mail/templates/crewchange%20crew/${agencyId}/true`);
      if (this.callId === callId && this.agencyId === agencyId) {
        this.emailTemplates = Array.isArray(templates) ? templates : [];
      }
    },
    getPeopleItemBySelectedKeys() {
      const people = [];
      for (let i = 0; i < this.selectedItemKeys.length; i++) {
        people.push(
          // eslint-disable-next-line @typescript-eslint/no-loop-func
          this.people.filter((obj) => obj.ID === this.selectedItemKeys[i])
        );
      }
      return people;
    },
    getTasksFromPeople(peopleArray) {
      const tasks = [];
      for (let i = 0; i < peopleArray.length; i++) {
        // eslint-disable-next-line no-restricted-syntax
        for (const prop in peopleArray[i][0]) {
          if (prop.indexOf('Task_') === 0) {
            tasks.push(peopleArray[i][0][prop]);
          }
        }
      }
      const uniqueTasks = [...new Set(tasks)];
      return uniqueTasks;
    },
    retrieveUpcomingTasksPeople() {
      if (this.applicationStore.user.externalClientId != undefined) {
        this.isLoading = true;
        apiGet(`crewchange/upcomingTasksPeople/${this.applicationStore.user.externalClientId}`).then((result) => {
          this.upcomingPeople = GatUtils.makeCopyViaJson(result);
          this.isLoading = false;
        });
      }
    },
    getDataTypeByFieldTypeId(fieldType) {
      switch (fieldType) {
        case 2:
          return 'number';
        case 3:
          return 'date';
        case 12:
          return 'datetime';
        default:
          return undefined;
      }
    },
  },
};
</script>

<style scoped></style>
